import React from "react";

const CalculatePage = () => {
  return (
    <div>
      <h1>
        Скоро на сайте появится калькулятор, в котором вы сможете самостоятельно
        рассчитать стоимость работы
      </h1>
    </div>
  );
};

export default CalculatePage;
